import React from 'react';
import useTranslation from '../../hooks/useTranslation';
import { ScoopMarker, scoopVariantForKar } from './ScoopMarker';
import StatusPill from './StatusPill';
import { statusToText, statusPillForKar, truckNumber } from './truckStatus';
import { formatDistance } from '../../utils/geo';

/**
 * One truck row: mini scoop-marker + name + status pill + location text
 * (ellipsis) + distance in red. Used in the tracker "In de buurt" panel and
 * the Info live-status grid.
 */
function TruckCard({ kar, distanceKm = null, onSelect = null }) {
    const { t } = useTranslation();
    const pill = statusPillForKar(kar, t);
    const locationText = statusToText(kar, t);

    const body = (
        <>
            <ScoopMarker variant={scoopVariantForKar(kar)} number={truckNumber(kar)} size={34} />
            <div className="truck-card-main">
                <div className="truck-card-top">
                    <span className="truck-card-name">{kar.title}</span>
                    <StatusPill variant={pill.variant} label={pill.label} />
                </div>
                <div className="truck-card-bottom">
                    <span className="truck-card-location">{locationText}</span>
                    {distanceKm !== null && (
                        <span className="truck-card-distance">{formatDistance(distanceKm)}</span>
                    )}
                </div>
            </div>
        </>
    );

    if (onSelect) {
        return (
            <button type="button" className="truck-card truck-card-clickable" onClick={onSelect}>
                {body}
            </button>
        );
    }
    return <div className="truck-card">{body}</div>;
}

export default TruckCard;
